// @flow

type ArrayClassList = string[];
type ObjectClassList = {
    [index: string]: boolean,
};

type ClassList = string | ArrayClassList | ObjectClassList;

function combine(classList: ArrayClassList): string {
    return classList
        .map(className => className.trim())
        .filter(className => className.length >= 1)
        .join(" ");
}

export default function classNameOf(...classLists: ClassList[]): string {
    return combine(
        classLists.map(classList => {
            if (classList === null || classList === undefined) {
                return "";
            }

            // Just return the string as is.
            if (typeof classList === "string") {
                return classList;
            }

            // For an array of class names, just join them together.
            if (Array.isArray(classList)) {
                return combine(classList);
            }

            // For a dictionary of class names, filter all the entries where the value is `true`, and join the keys together.
            return combine(
                Object.entries(classList)
                    // eslint-disable-next-line no-unused-vars
                    .filter(([key, value]) => value)
                    .map(([key]) => key),
            );
        }),
    );
}
